const degree_cooling =
    [
        "16°", "17°", "18°", "19°", "20°", "21°", "22°", "23°", "24°", "25°",
        "26°", "27°", "28°", "29°", "30°"
    ];
const degreeـheating  = [
    "50°", "51°", "52°", "53°", "54°", "55°", "56°", "57°", "58°", "59°",
    "60°", "61°", "62°", "63°", "64°", "65°", "66°", "67°", "68°", "69°",
    "70°", "71°", "72°", "73°", "74°", "75°", "76°", "77°", "78°", "79°",
    "80°", "81°", "82°", "83°", "84°", "85°", "86°", "87°", "88°", "89°", "90°"
];
const fragrance = ['شکوفه گیلاس', 'وانیلا اسپایس', 'اونتوس' , 'یاس سفید' , 'آمونیا' , 'کاج جنگلی'];
const volume = ['کم', 'متوسط', 'زیاد'];
export const allOptions = [degree_cooling, degreeـheating, fragrance, volume];



export const labels = ['درجه دستگاه سرمايش', 'درجه دستگاه گرمايش', 'نوع رايحه اتاق', 'صداى موسيقى'];
